import { render, staticRenderFns } from "./HooksSettings.vue?vue&type=template&id=099b8ec4&scoped=true&"
import script from "./HooksSettings.vue?vue&type=script&lang=js&"
export * from "./HooksSettings.vue?vue&type=script&lang=js&"
import style0 from "./HooksSettings.vue?vue&type=style&index=0&id=099b8ec4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099b8ec4",
  null
  
)

export default component.exports